import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { BlogCategoryView } from 'alakai-aloha-shared/public-ui';
import {
  islandApplicableDocumentFilter,
  islandScopedDocumentFilter,
  sanityFetch,
} from '../../lib/sanity';
import ScrollToTop from '../../components/shared/ScrollToTop';
import { urlFor } from '../../lib/sanityImage';
import { buildRuntimeCanonicalUrl } from '../../lib/siteUrls';
import { getRuntimeSiteContext } from '../../lib/siteContext';

function mapCardPost(post) {
  return {
    id: post._id,
    title: post.title,
    slug: post.slug?.current || post.slug,
    excerpt: post.excerpt,
    imageUrl: post.mainImage?.asset
      ? urlFor(post.mainImage).width(400).height(300).auto('format').quality(70).url()
      : undefined,
    imageAlt: post.mainImage?.alt || post.title,
  };
}

const CategoryPage = () => {
  const { slug } = useParams();
  const { islandConfig } = getRuntimeSiteContext();
  const [category, setCategory] = useState(null);
  const pageUrl = buildRuntimeCanonicalUrl(`/blog/category/${slug}`);
  const pageTitle = category?.title
    ? `${category.title} | ${islandConfig.shortTitle} Blog | Alaka'i Aloha`
    : `${islandConfig.shortTitle} Blog Category | Alaka'i Aloha`;
  const pageDescription = category?.description
    ? category.description
    : category?.title
      ? `Browse ${islandConfig.title} travel articles in the ${category.title} category.`
      : `Browse ${islandConfig.title} travel articles by category.`;

  useEffect(() => {
    sanityFetch(
      `*[_type == "category" && ${islandApplicableDocumentFilter()} && slug.current == $slug][0]{
        title,
        description,
        "posts": *[_type=="blogPost" && ${islandScopedDocumentFilter()} && references(^._id)] | order(publishedAt desc) {
          _id,
          title,
          slug,
          excerpt,
          publishedAt,
          mainImage { asset->{ url }, alt }
        }
      }`,
      { slug },
    )
      .then((data) => {
        setCategory({
          title: data?.title,
          description: data?.description,
          posts: (data?.posts || []).map(mapCardPost),
        });
      });
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
      </Helmet>
      <ScrollToTop />
      <BlogCategoryView
        title={category?.title || ''}
        description={category?.description}
        posts={category?.posts || []}
      />
    </>
  );
};

export default CategoryPage;
